import { useEffect, useState } from 'react';
import '../styles/contact.css';
import { Fade } from 'react-reveal';
import { CONTACT_TITLE } from '../constants';

const Contact = () => {
    var autores = 'Thankyou for contacting us! We have received your message and will reach out to you shortly!';
    const [autoresponse, setAutoresponse] = useState(autores);


    const CONTACT_KEY = process.env.REACT_APP_CONTACT_KEY;
    const BASE_URL = process.env.REACT_APP_BASE_URL;

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        work: '',
        message: ''
    });

    // const url = `https://formsubmit.co/${CONTACT_KEY}`;

    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
    }

    useEffect(() => {
        if (window.scrollY != 0) {
            //user scrolled to the top of the page
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
        // console.log('url: ' + url);
    }, []);

    return (
        <div className="container">
            <Fade>
                <form className="contact-form"
                    // action="https://formsubmit.co/minganicdesigns" method="POST"
                    // action={`https://formsubmit.co/${CONTACT_KEY}`} method="POST"
                    action={`https://formsubmit.co/${CONTACT_KEY}`} method="POST"
                // onSubmit={(e) => { handleSubmit(e) }}
                >

                    {/* <div className="row py-3 py-md-5">

                        <p>We would love to hear from you,
                            <br />Let's connect <span><img className='svg-icon-xl' src="/assets/icons/hello.svg" alt="arrow" /></span>
                        </p>
                    </div> */}

                    <div className="row py-3 py-md-5">
                        <p className='multi-line content-1'>
                            {CONTACT_TITLE}
                            <span><img className='svg-icon-xl' src="/assets/icons/hello.svg" alt="arrow" /></span>
                        </p>

                    </div>

                    {/* <div className="row">
                    <div className="col-6">
                        <label htmlFor="name">Your Name</label>
                        <input type="text" placeholder="Enter your name" />
                    </div>

                    <div className="col-6">
                        <label htmlFor="email">Your Email</label>
                        <input type="email" placeholder="Enter your email" />
                    </div>

                    <div className="col-6">
                        <label htmlFor="email">Your Email</label>
                        <input type="email" placeholder="Enter your email" />
                    </div>

                    <div className="col-6">
                        <label htmlFor="work">What would you like us to do?</label>
                        <select name="work" id="work">
                            <option value="-1">Select</option>
                            <option value="residential">Residential</option>
                            <option value="commercial">Commercial</option>
                            <option value="restaurant">Restaurants, Hotels & Outlets</option>
                            <option value="renovation">Renovation</option>
                            <option value="advice">Designer Advice</option>
                            <option value="other">Other</option>
                        </select>
                    </div>

                    <div className="col-6">
                        <label htmlFor="message">Message</label>
                        <input type="message" placeholder="Enter your message" />
                    </div>
                </div>  */}
                    {/* end div row */}

                    <div className="row form-row">
                        <div className="col-12 col-md-6 order-2 order-md-1">
                            <div className="form-box">
                                <label htmlFor="name">Your Name</label>
                                <input type="text" name="name" placeholder="Enter your name"
                                    value={formData['name']}
                                    onChange={(e) => handleChange('name', e.target.value)}
                                    required />
                            </div>


                            <div className="form-box">
                                <label htmlFor="email">Your Email</label>
                                <input type="email" name="email" placeholder="Enter your email"
                                    value={formData['email']}
                                    onChange={(e) => handleChange('email', e.target.value)}
                                    required />
                            </div>

                            <div className="form-box">
                                <label htmlFor="phone">Your Phone</label>
                                <input type="tel" id="phone" name="phone"
                                    pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
                                    placeholder="Enter your phone number"
                                    value={formData['phone']}
                                    onChange={(e) => handleChange('phone', e.target.value)}
                                    required />
                            </div>

                            <div className="form-box">
                                <label htmlFor="work">What are you interested in?</label>
                                <select className="" name="work" id="work"
                                    value={formData['work']}
                                    onChange={(e) => handleChange('work', e.target.value)}
                                    required>
                                    <option>Select</option>
                                    <option value="residential">Residential</option>
                                    <option value="commercial">Commercial</option>
                                    <option value="restaurant">Restaurants, Hotels & Outlets</option>
                                    <option value="renovation">Renovation</option>
                                    <option value="advice">Designer Advice</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>

                            <div className="form-box">
                                <label htmlFor="message">Message</label>
                                <textarea name="message" id="message" cols="30" rows="3"
                                    value={formData['message']}
                                    onChange={(e) => handleChange('message', e.target.value)}
                                    required></textarea>
                            </div>

                            <div className="form-box">
                                <button className="contact-btn content-2 button-fill" type="submit">
                                    Send<img id="send-arrow" src="/assets/icons/arrow_right_icon.svg" alt="arrow" />
                                </button>
                            </div>
                            <input type="hidden" name="_template" value="table" />
                            <input type="hidden" name="_autoresponse" value={autoresponse}></input>
                            <input type="hidden" name="_next" value={`${BASE_URL}/thankyou`}></input>
                        </div>

                        <div className="col-12 col-md-6 order-1 order-md-2">
                            <div className="form-box">
                                <img className="img-fluid" src="/assets/images/contact/banner.jpg" alt="" />
                            </div>
                        </div>
                    </div> {/* end div row */}

                </form>
            </Fade>
        </div >
    );
}

export default Contact;